var _rect, _mask, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 209,
    fill: "none",
    viewBox: "0 0 165 209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 165,
    y: 44,
    fill: "url(#paint0_linear)",
    rx: 82.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "1z7n28jrla",
    width: 165,
    height: 165,
    x: 0,
    y: 44,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 165,
    y: 44,
    fill: "url(#paint1_linear)",
    rx: 82.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#1z7n28jrla)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M110.619 200.97c0-2.119.853-4.151 2.371-5.65 1.519-1.498 3.578-2.34 5.725-2.34h16.19c2.147 0 4.206-.841 5.724-2.34 1.518-1.498 2.371-3.53 2.371-5.649s-.853-4.152-2.371-5.65c-1.518-1.498-3.577-2.34-5.724-2.34H86.334c-2.147 0-4.206-.842-5.724-2.34-1.518-1.498-2.371-3.531-2.371-5.65s.853-4.151 2.37-5.649c1.519-1.499 3.578-2.34 5.725-2.34h16.19c2.147 0 4.206-.842 5.724-2.34 1.519-1.499 2.371-3.531 2.371-5.65s-.852-4.151-2.371-5.65c-1.518-1.498-3.577-2.34-5.724-2.34h-48.57c-2.148 0-4.207-.841-5.725-2.34-1.518-1.498-2.37-3.53-2.37-5.649s.852-4.152 2.37-5.65c1.518-1.498 3.578-2.34 5.724-2.34h16.19c2.148 0 4.207-.842 5.725-2.34 1.518-1.498 2.37-3.531 2.37-5.65s-.852-4.151-2.37-5.649c-1.518-1.499-3.577-2.34-5.724-2.34H21.573c-2.147 0-4.206-.842-5.724-2.34-1.518-1.499-2.371-3.531-2.371-5.65s.853-4.151 2.37-5.65c1.519-1.498 3.578-2.34 5.725-2.34h16.19c2.147 0 4.206-.841 5.724-2.34 1.518-1.498 2.371-3.53 2.371-5.65 0-2.118-.853-4.15-2.37-5.649-1.519-1.498-3.578-2.34-5.725-2.34H7.002c-7.94 15.337-11.14 32.639-9.2 49.756 1.94 17.117 8.932 33.294 20.109 46.522 11.177 13.227 26.045 22.922 42.758 27.879 16.713 4.957 34.532 4.958 51.246.002-.842-1.286-1.292-2.783-1.296-4.314z",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M151.517 78.921c-3.703-5.663-8.076-10.859-13.023-15.475H65.411c-2.032 0-3.98.808-5.417 2.244-1.437 1.437-2.244 3.386-2.244 5.417 0 2.032.807 3.98 2.244 5.417 1.436 1.437 3.385 2.244 5.417 2.244h86.106v.153zM157.338 124.732c-2.031 0-3.98.807-5.417 2.244-1.436 1.436-2.243 3.385-2.243 5.417 0 2.031.807 3.98 2.243 5.417 1.437 1.436 3.386 2.243 5.417 2.243h6.282c.929-5.054 1.39-10.182 1.379-15.321h-7.661zM157.033 88.88c-.538 1.522-1.533 2.84-2.85 3.772-1.317.933-2.89 1.435-4.504 1.437h-38.303c-2.032 0-3.981.808-5.417 2.244-1.437 1.437-2.244 3.385-2.244 5.417s.807 3.98 2.244 5.417c1.436 1.437 3.385 2.244 5.417 2.244h52.245c-1.381-7.079-3.593-13.97-6.588-20.53z",
    opacity: 0.47
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5B6781",
    d: "M127.956 0H42.391c-5.907 0-10.696 4.769-10.696 10.652v127.82c0 5.883 4.789 10.652 10.696 10.652h85.565c5.907 0 10.696-4.769 10.696-10.652V10.652C138.652 4.769 133.863 0 127.956 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4145",
    d: "M117.261 0H31.696C25.789 0 21 4.769 21 10.652v127.82c0 5.883 4.789 10.652 10.696 10.652h85.565c5.907 0 10.696-4.769 10.696-10.652V10.652C127.957 4.769 123.168 0 117.261 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAECF3",
    d: "M117.261 10.652H31.695V127.82h85.566V10.652z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4D8",
    d: "M53.086 42.607h53.478c1.419 0 2.779.561 3.782 1.56 1.003.999 1.566 2.353 1.566 3.766v79.888H47.738V47.933c0-1.413.564-2.767 1.567-3.766 1.002-.999 2.363-1.56 3.781-1.56z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B6781",
    d: "M117.261 10.652H31.695v21.303h85.566V10.652z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.739 42.607h53.478c1.418 0 2.778.561 3.781 1.56 1.003.999 1.567 2.353 1.567 3.766v79.888H42.391V47.933c0-1.413.563-2.767 1.566-3.766 1.003-.999 2.363-1.56 3.782-1.56z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A65C7",
    d: "M47.739 42.607h53.478c1.418 0 2.778.561 3.781 1.56 1.003.999 1.567 2.353 1.567 3.766V63.91H42.391V47.933c0-1.413.563-2.767 1.566-3.766 1.003-.999 2.363-1.56 3.782-1.56z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101.218 42.607H79.826c-2.953 0-5.347 2.384-5.347 5.326 0 2.941 2.394 5.326 5.347 5.326h21.392c2.953 0 5.347-2.385 5.347-5.326 0-2.942-2.394-5.326-5.347-5.326z",
    opacity: 0.08
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101.217 42.607H90.522c-2.954 0-5.348 2.384-5.348 5.326 0 2.941 2.394 5.326 5.348 5.326h10.695c2.954 0 5.348-2.385 5.348-5.326 0-2.942-2.394-5.326-5.348-5.326z",
    opacity: 0.08
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M106.565 47.933c0-2.942-2.395-5.326-5.348-5.326-2.954 0-5.348 2.384-5.348 5.326 0 2.941 2.394 5.326 5.348 5.326 2.953 0 5.348-2.385 5.348-5.326z",
    opacity: 0.08
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#7AC943",
    d: "M71.94 99.283l-7.209-6.101c-1.99-1.685-4.975-1.444-6.667.539-1.692 1.982-1.45 4.955.541 6.639l7.208 6.101c1.99 1.685 4.976 1.444 6.667-.539 1.692-1.982 1.45-4.955-.54-6.64z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#7AC943",
    d: "M85.136 79.447l-19.344 20.679c-1.78 1.904-1.674 4.884.237 6.658 1.912 1.773 4.904 1.667 6.685-.236l19.344-20.68c1.78-1.903 1.675-4.884-.237-6.657-1.911-1.773-4.904-1.668-6.684.236z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.281 96.804c0-2.762-2.238-5-5-5-2.761 0-5 2.238-5 5 0 2.761 2.239 5 5 5 2.762 0 5-2.239 5-5z",
    opacity: 0.08
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M85.137 79.447l-6.448 6.893c-1.78 1.903-1.675 4.884.237 6.657 1.911 1.773 4.904 1.668 6.684-.236l6.448-6.893c1.781-1.903 1.675-4.884-.236-6.657-1.912-1.773-4.904-1.668-6.685.236z",
    opacity: 0.26
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.821 79.21c-1.911-1.773-4.904-1.667-6.685.237-1.78 1.903-1.674 4.884.237 6.657 1.911 1.773 4.904 1.668 6.685-.236 1.78-1.903 1.674-4.884-.237-6.657z",
    opacity: 0.26
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#525C72",
    d: "M53.086 20.984c0-2.942-2.394-5.326-5.347-5.326-2.954 0-5.348 2.384-5.348 5.326 0 2.941 2.394 5.326 5.348 5.326 2.953 0 5.347-2.385 5.347-5.326zM90.522 15.658H69.131c-2.954 0-5.348 2.384-5.348 5.326 0 2.941 2.394 5.326 5.348 5.326h21.391c2.954 0 5.348-2.385 5.348-5.326 0-2.942-2.394-5.326-5.348-5.326z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#333E4D",
    d: "M117.261 0H31.696c-2.837 0-5.558 1.122-7.563 3.12C22.127 5.117 21 7.827 21 10.652v127.82c0 2.825 1.127 5.535 3.133 7.532 2.006 1.998 4.726 3.12 7.563 3.12h85.565c2.837 0 5.557-1.122 7.563-3.12 2.006-1.997 3.133-4.707 3.133-7.532V10.652c0-2.825-1.127-5.535-3.133-7.532-2.006-1.998-4.726-3.12-7.563-3.12zm0 127.82H31.696V10.652h85.565V127.82zM144 37.28c0-2.94-2.394-5.325-5.347-5.325-2.954 0-5.348 2.385-5.348 5.326v10.652c0 2.941 2.394 5.325 5.348 5.325 2.953 0 5.347-2.384 5.347-5.325V37.28z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B6781",
    d: "M74.479 143.798c2.953 0 5.347-2.385 5.347-5.326s-2.394-5.326-5.347-5.326c-2.954 0-5.348 2.385-5.348 5.326s2.394 5.326 5.348 5.326z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M85.174 10.652h32.087L31.695 95.865V63.91l53.479-53.258z",
    opacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 165,
    x2: 174.325,
    y1: 44,
    y2: 198.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD45D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C16A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 113.612,
    x2: 19.187,
    y1: 210.317,
    y2: 191.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD45D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C16A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessImage);
export default __webpack_public_path__ + "static/media/successImage.7e1f747e42610b6b6cdc905c7b2f50fc.svg";
export { ForwardRef as ReactComponent };